import ParagonAward from '../../images/ParagonAward2022.png';
import DavidMilksAward from '../../images/DavidMilksAward2025.png';
import DanGerlachAward from '../../images/DanGerlachAward2025.png';

export const BADGE_TYPES = {
    paragon: {
        id: 'paragon',
        name: 'The SDSIC Paragon Award',
        description: 'Honors the unparalleled dedication and exceptional work ethic of an outstanding individual within SDSIC. Celebrates collaboration, inclusivity, and unwavering support that fuels the growth and momentum of our organization.',
        criteria: 'Selected by community vote at the annual SDSIC event.',
        color: '#FF6600',
        colorLight: '#FFF3E8',
        colorDark: '#993D00',
        icon: 'star',
        image: ParagonAward,
    },
    david_milks_memorial: {
        id: 'david_milks_memorial',
        name: 'The David H. Milks SDSIC Memorial Award',
        description: 'Honors the memory of David Milks, a founding member of SDSIC. Recognizes those who have made extraordinary contributions towards advancing the SDS Industry Consortium throughout the year.',
        criteria: 'Selected by community vote at the annual SDSIC event.',
        color: '#003E7E',
        colorLight: '#E8F0FA',
        colorDark: '#001F3F',
        icon: 'shield',
        image: DavidMilksAward,
    },
    dan_gerlach_innovation: {
        id: 'dan_gerlach_innovation',
        name: 'The Dan Gerlach SDSIC Innovation Award',
        description: 'Honors Dan Gerlach, a founding member of SDSIC who architected and developed original 3D Substation Design Tools. Recognizes those who have made the most innovative contributions to our industry.',
        criteria: 'Selected by community vote at the annual SDSIC event.',
        color: '#FF6600',
        colorLight: '#FFF3E8',
        colorDark: '#993D00',
        icon: 'bolt',
        image: DanGerlachAward,
    },
};
